import { useMutation, useQuery } from "@apollo/client";
import { Empty, message } from "antd";

import {
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateDocument,
  CredentialVerificationCaseV1UpdateInput,
  CredentialVerificationCaseV1ApplicationReviewInput,
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1FieldsFragment,
} from "../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { Checklist } from "./checklist";
import { useState } from "react";

interface ChecklistContainerProps {
  caseId: string;
}

export const ChecklistContainer: React.FC<ChecklistContainerProps> = (props) => {
  const [isSuccess, setIsSuccess] = useState(false as boolean);
  const {
    data: caseData,
    loading: caseLoading,
    error: caseError,
  } = useQuery(
    CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Document,
    {
      variables: {
        id: props.caseId,
      },
    }
  );

  const [credentialVerificationUpdate] = useMutation(
    CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateDocument
  );

  const handleComplete = async (
    values: CredentialVerificationCaseV1ApplicationReviewInput
  ) => {
    try {
      const credentialVerificationUpdateVariables: CredentialVerificationCaseV1UpdateInput =
        {
          id: props.caseId,
          caseDetails: {
            applicationReview: {
              ...values,
            },
          },
        };
      const result = await credentialVerificationUpdate({
        variables: { input: credentialVerificationUpdateVariables },
      });
      if (result.data?.credentialVerificationCaseV1Update?.status.success) {
        setIsSuccess(result.data?.credentialVerificationCaseV1Update?.status?.success as boolean);
        message.success("Affirmations saved successfully");
      } else {
        message.error(
          `Error saving Affirmations: ${result.data?.credentialVerificationCaseV1Update?.status.errorMessage}`
        );
      }
    } catch (error) {
      message.error(`Error saving Affirmations: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={caseLoading}
      error={caseError}
      hasData={!!caseData}
      hasDataComponent={
        <Checklist
          data={caseData?.credentialVerificationCaseV1 as CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1FieldsFragment}
          onSave={handleComplete}
          isSuccess={isSuccess}
        />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
